import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {Observable, Subscription} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';
import {Chart, ChartModule} from 'angular-highcharts';
import {ChartTiktokService} from '../../chart-tiktok.service';
import {AsyncPipe, DecimalPipe, JsonPipe, NgClass, NgIf} from '@angular/common';
import {ShareModule} from '../../../share/share.module';

@Component({
    selector: 'app-profile-audit-audience',
    // standalone: true,
    // imports: [
    //   AsyncPipe,
    //   NgIf,
    //   NgClass,
    //   ChartModule,
    //   ShareModule,
    //   DecimalPipe,
    //   JsonPipe
    // ],
    templateUrl: './profile-audit-audience.component.html',
    styleUrl: './profile-audit-audience.component.scss',
    standalone: false
})
export class ProfileAuditAudienceComponent implements OnInit, OnDestroy {

  profileState: Observable<fromProfile.State>;
  profileSubscription: Subscription;
  chartsAudience: Chart[];

  constructor(
    private store: Store<fromApp.AppState>
  ) { }
  ngOnInit(): void {
    this.profileState = this.store.select('profile');
    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        if (state.audienceTiktok !== null) {
          this.chartsAudience = [];
          this.chartsAudience.push(
            ChartTiktokService.getGenderChart(state.audienceTiktok.audience),
            ChartTiktokService.getAgeAudienceChart(state.audienceTiktok.audience),
            ChartTiktokService.getLanguageAudienceChart(state.audienceTiktok.audience),
            ChartTiktokService.getQualityDistributionChart(state.audienceTiktok.audience)
          );
        }

      }
    );
  }

  ngOnDestroy(): void {
    this.profileSubscription.unsubscribe();
  }

}
